import { PLATFORM_ID, Provider } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { TelemetryService } from './telemetry.service';
import { BrowserTelemetryService } from './browser-telemetry.service';
import { ServerTelemetryService } from './server-telemetry.service';

export function provideTelemetry(): Provider[] {
  return [
    {
      provide: TelemetryService,
      useFactory: (platformId: object) => {
        if (isPlatformBrowser(platformId)) {
          return new BrowserTelemetryService();
        }
        return new ServerTelemetryService();
      },
      deps: [PLATFORM_ID],
    },
  ];
}
